import { Flex } from 'components/flex';
import { formatPrice } from 'utils/helpers';
import { PayoutType, BadgeColor, BadgePadding } from 'types';

import * as Styles from './styles';
import { sumItems } from './helpers';
import { CardProps, PriceProps, AdjustmentCardProps } from './types';

export const Card = ({
  type,
  title,
  value,
  description,
  isDeduction,
  otherEventAdjustments,
}: CardProps) => {
  const isNegativeEarning = type === PayoutType.NegativeEarnings && isDeduction;
  const isShowAdjustments =
    isNegativeEarning &&
    otherEventAdjustments &&
    otherEventAdjustments?.length > 0;

  return (
    <Flex column>
      <Flex
        gap={16}
        fullWidth
        alignItems="center"
        justifyContent="space-between"
      >
        <Flex gap={8}>
          <p>{title}</p>
          {description && <p>{description}</p>}
        </Flex>
        {typeof value === 'string' ? (
          <Styles.Value isDeduction={isDeduction}>{value}</Styles.Value>
        ) : (
          value
        )}
      </Flex>

      {isShowAdjustments &&
        otherEventAdjustments.map((adjustment, index) => (
          <Styles.Value key={index} isDeduction className="caption-regular">
            {adjustment?.adjustmentReason} from{' '}
            {adjustment?.originalEvent?.name} {formatPrice(adjustment?.amount)}
          </Styles.Value>
        ))}
    </Flex>
  );
};

export const Price = ({ payout, totalPrice, showPayoutPrice }: PriceProps) => (
  <Styles.StyledBadge
    padding={BadgePadding.Big}
    styleType={BadgeColor.Blue}
    text={
      <>
        <p className="semibold">Payout</p>
        <p className="semibold">
          {showPayoutPrice ? formatPrice(payout?.amount) : totalPrice}
        </p>
      </>
    }
  />
);

export const AdjustmentCard = ({ title, items }: AdjustmentCardProps) => {
  const total = sumItems(items);
  if (!items.length) {
    return null;
  }

  return (
    <Flex gap={8} fullWidth flexDirection="column">
      <Flex
        gap={16}
        fullWidth
        alignItems="center"
        justifyContent="space-between"
      >
        <p>{title}</p>
        <Styles.Value isDeduction>-{formatPrice(Math.abs(total))}</Styles.Value>
      </Flex>

      {items.map((item) => (
        <Flex
          gap={16}
          fullWidth
          key={item.id}
          alignItems="center"
          justifyContent="space-between"
        >
          <Styles.ItemDescription className="caption-regular">
            {title} from
            {` checkout #${item.checkoutId} · ${item?.originalEvent?.name || item.event?.name}`}
          </Styles.ItemDescription>

          <Styles.Value isDeduction>
            -{formatPrice(Math.abs(item.amount))}
          </Styles.Value>
        </Flex>
      ))}
    </Flex>
  );
};
